export default __webpack_public_path__ + "static/media/nightmarket_dishes.3542e991.png";